import React from 'react';

export const Refunds = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Manage Refunds</h1>
      <div className="bg-white rounded-lg shadow-sm p-6">
        <p className="text-gray-500">Refund management functionality coming soon...</p>
      </div>
    </div>
  );
};